

const AUTHORIZATION_TOKEN_KEY = 'authorization-token';

export function setAuthorizationToken(token: string){
  localStorage.setItem(AUTHORIZATION_TOKEN_KEY, token);
}

export function getAuthorizationToken(){
  return localStorage.getItem(AUTHORIZATION_TOKEN_KEY);
}

export function removeAuthorizationToken(){
  localStorage.removeItem(AUTHORIZATION_TOKEN_KEY);
}
